import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { HierarchyWidgetsModule } from '../hierarchy/hierarchy-widgets.module';
import { FilterComponent } from './widgets/filter/filter.component';

@NgModule({
  declarations: [FilterComponent],
  imports: [SharedModule, HierarchyWidgetsModule],
  exports: [FilterComponent]
})
export class FilterWidgetsModule {}
